<app-loader *ngIf="isDisabled"></app-loader>
<div class="card">
    <div class="card-header">
        Assigned to
    </div>
    <div class="card-body" style="overflow: auto;height: 460px;">
        <div class="container">
            <div class="row">
                <div class="col-md mx-1 px-1 bghighlight">
                    <label class="text-label">Employee</label><br />
                    <label class="Label1">
                        <div class="row no-gutters cursor-pointer" style="align-items: center;width: 300px;">
                            <div class="col-2">
                                <img *ngIf="InputData.Photo != null && InputData.Photo != ''" mat-card-image
                                    class="userImage" [src]="common.PhotoLink(InputData.Photo)" />
                                <div *ngIf="InputData.Photo == null || InputData.Photo == ''" class="initial-image">
                                    <div class="image">
                                        {{common.getInitial(InputData.EmpName)}}
                                    </div>
                                </div>
                            </div>
                            <div class="col-9 userdetail">
                                <span class="text-label">{{InputData.EmpName}}</span><br />
                                <span class="text-label-light">#{{InputData.EmpCode}}</span><br />
                                <span class="text-label-light">{{InputData.DesignationName}}</span>
                            </div>
                        </div>
                    </label>
                </div>
                <div class="col-md mx-1 px-1 bghighlight">
                    <div class="row">
                        <div class="text-label">Complaint ID</div>
                    </div>
                    <div class="row text-right" style="font-size: 15px;">
                        <div>{{InputData.ESS_HelpDeskRequestId}} </div>
                    </div>
                </div>
                <div class="col-md mx-1 px-1 bghighlight">
                    <div class="row">
                        <div class="text-label">Complaint Type</div>
                    </div>
                    <div class="row text-right" style="font-size: 15px;">
                        <div>{{InputData.ComplaintType}}</div>
                    </div>
                </div>
                <div class="col-md mx-1 px-1 bghighlight">
                    <div class="row">
                        <div class="text-label">Contact No.</div>
                    </div>
                    <div class="row text-right" style="font-size: 15px;">
                        <div>{{InputData.EmpContact}}</div>
                    </div>
                </div>
            </div>
            <div class="row" style="margin-top: 3px;">
                <div class="col-md mx-1 px-1 bghighlight">
                    <div class="row">
                        <div class="text-label">Branch</div>
                    </div>
                    <div class="row text-right" style="font-size: 15px;">
                        <div>{{InputData.BranchName}}</div>
                    </div>
                </div>
                <div class="col-md mx-1 px-1 bghighlight">
                    <div class="row">
                        <div class="text-label">Client</div>
                    </div>
                    <div class="row text-right" style="font-size: 15px;">
                        <div>{{InputData.ClientLocation}}</div>
                    </div>
                </div>
                <div class="col-md mx-1 px-1 bghighlight">
                    <div class="row">
                        <div class="text-label">Site</div>
                    </div>
                    <div class="row text-right" style="font-size: 15px;">
                        <div>{{InputData.SiteName}}</div>
                    </div>
                </div>
                <div class="col-md mx-1 px-1 bghighlight">
                    <div class="row">
                        <div class="text-label">Site Supervisor</div>
                    </div>
                    <div class="row text-right" style="font-size: 15px;">
                        <div>{{InputData.SiteSuperVisorName}}</div>
                    </div>
                </div>
            </div>
            <div class="row" style="margin-top: 3px;">
                <div class="col-md mx-1 px-1 bghighlight">
                    <div class="row">
                        <div class="text-label">Site Supervisor Email</div>
                    </div>
                    <div class="row text-right" style="font-size: 15px;">
                        <div>{{InputData.SupervisorEmailId}}</div>
                    </div>
                </div>
                <div class="col-md mx-1 px-1 bghighlight">
                    <div class="row">
                        <div class="text-label">Site Supervisor Contact no</div>
                    </div>
                    <div class="row text-right" style="font-size: 15px;">
                        <div>{{InputData.SupervisorContactNo}}</div>
                    </div>
                </div>
                <div class="col-md mx-1 px-1 bghighlight">
                    <div class="row">
                        <div class="text-label">Description</div>
                    </div>
                    <div class="row text-right" style="font-size: 15px;">
                        <div>{{InputData.Description}}</div>
                    </div>
                </div>
            </div>
            <hr>
            <div class="row m-1">
                <div class="col-md-4">
                    <label for="ComplaintType" class="Label">Complaint Type <span class="text-danger">*</span></label>
                    <ng-select [items]="ComplaintTypeData" bindLabel="ComplaintType" bindValue="ESS_ComplaintTypeID"
                        placeholder="Complaint Type" [(ngModel)]="ESS_ComplaintTypeId" [virtualScroll]="true"
                        name="ComplaintType" required>
                    </ng-select>
                    <div class="invalid-feedback">
                        Please select Complaint Type
                    </div>
                </div>
                <div class="col-md-8 px-1">
                    <label class="form-font-label">User <span class="text-danger">*</span></label>
                    <ng-select [items]="UserMaster" bindLabel="UserCode" bindValue="UserMasterId"
                        (change)="onUserChange()" placeholder="User" [(ngModel)]="UserId" name="userMaster">
                    </ng-select>
                    <div class="invalid-feedback">
                        Please select User
                    </div>
                </div>
            </div>
            <div class="row m-1">
                <div class="col-md-12">
                    <label class="form-font-label">Remarks</label>
                    <textarea class="form-control" id="Remar" rows="3" placeholder="Please Enter Remarks"
                        [(ngModel)]="Remarks"></textarea>
                </div>
            </div>
        </div>
    </div>
    <div class="card-footer">
        <div class="row">
            <div class="col">
                <div class="row">
                </div>
                <div class="row">
                </div>
            </div>
            <div class="col-auto">
                <button class="btn btn-sm btn-outline-primary" name="cancel" (click)="Close(false)">
                    <i class="bi bi-x-lg" *ngIf="!isDisabled"></i>
                    <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"
                        *ngIf="isDisabled"></span>
                    {{!isDisabled?'Cancel':'Loading...'}}
                </button>&nbsp;&nbsp;
                <button class="btn btn-sm btn-primary" name="save" (click)="save('Assigned')">
                    <i class="bi bi-save" *ngIf="!isDisabled"></i>
                    <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"
                        *ngIf="isDisabled"></span>
                    {{!isDisabled?'Assign':'Loading...'}}
                </button>
            </div>
        </div>
    </div>
</div>